module.exports = __webpack_public_path__ + "static/media/breakfast.2b5e89e8.jpg";